import React from 'react';
import { Alert, Card, CardBody, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { Colxx } from 'Components/CustomBootstrap';
import { logoutUser } from 'Redux/actions';
import withPasswordProtection from '../../util/WithPasswordProtection';
import { PurchaseLedger } from './purchase-ui';
import '../warehousing/monthly-report.css';
import './purchase-ui.css';

function ProductJournal({ location }) {
    if (!(localStorage.getItem('user_can') || '').split(',').includes('manage-accounting-journal')) return <Alert color="warning">دسترسی مجاز نیست.</Alert>;
    return <Row className="invoice"><Colxx xxs="12"><Card><CardBody>
        <PurchaseLedger location={location} standalone />
    </CardBody></Card></Colxx></Row>;
}
export default connect(null, { logoutUser })(withPasswordProtection('accounting/transactions/password', 5)(ProductJournal));
